module.exports = __webpack_public_path__ + "img/SERVICIO.4e54687f.svg";